import styled from 'styled-components';
import React from 'react';
import { Loading } from '@ui/Loading';
import { EXECUTION_NODE_TYPES } from '../index';
import { Container } from '@ui';
import { colorPalette } from '@theme';

export const Wrapper = styled.div`
  border: ${({ $selected, theme }) =>
    $selected ? `2px solid ${colorPalette.secondary.blue}` : `1px solid ${theme.themeColors.border}`};
  border-radius: 5px;
  background: ${({ theme }) => theme.themeColors.componentNoOpacity};
  box-shadow: ${({ $selected, theme }) => ($selected ? `0 0 0 1px ${theme.themeColors.text}` : 'none')};
`;

const NodeLoadingContentWrapper = styled.div`
  position: absolute;
  top: 25px;
  left: 1px;
  bottom: 1px;
  right: 1px;
  border-radius: 2px;

  background: ${({ theme }) => theme.themeColors.component};
`;

const enableQueryStartedMessage = (data, name) => {
  const { type } = data;
  const isExecutionNode = EXECUTION_NODE_TYPES.includes(type);
  if (isExecutionNode) {
    if (data.isWorking || data.isComplete || data.answer === 'Working...') {
      return false;
    }
    if (name === 'Start') {
      return false;
    }
    return true;
  } else {
    return false;
  }
};

export const NodeWrapper = ({ children, data, name, nodeData = {}, excludeFromReadOnly = false }) => {
  const { selected } = nodeData;
  const { isQueryStarted, id } = data;
  const showLoading = false && enableQueryStartedMessage(data, name) && isQueryStarted;
  const className = excludeFromReadOnly ? undefined : 'read-only-disable';
  if (showLoading) {
    return (
      <Wrapper $selected={selected} className={className}>
        <NodeLoadingContentWrapper>
          <Container top={24}>
            <Loading noVerticalPadding message={'Awaiting previous node to finish'} />
          </Container>
        </NodeLoadingContentWrapper>
        {children}
      </Wrapper>
    );
  }
  return (
    <Wrapper $selected={selected} className={className}>
      {children}
    </Wrapper>
  );
};
